<template>

    <panel-navigation>
      
      <dialog-add-business ref="dialogAddBusiness"></dialog-add-business>

      <h1 class="text-lg font-semibold mb-3">Admin</h1>

      <hr class="border-b border-gray-100 mb-3">

      <v-skeleton-loader v-if="fetchingBusinesses" type="article, article, article"></v-skeleton-loader>

      <div class="dashboard-box" v-if="!fetchingBusinesses && businesses.length == 0">
        <v-card
          class="pa-2"
          tile
        >
          <div class="p-3">

            <br /><br /><br /><br />

            <div class="dashboard-box-iconsquare">
              <div class="dashboard-box-icon-background"></div>
              <div class="dashboard-box-icon">
                <i class="mdi mdi-briefcase-outline"></i>
              </div>
            </div>

            <div style="text-align: center;">
              <div class="pt-2 pb-2">
                <strong>No Businesses Yet</strong>
              </div>

              <div class="text-sm mb-4 text-gray-600">
                You have no businesses yet. Use our tools to add businesses.
              </div>

              <br />

              <div class="border-1 border-blue bg-blue text-white text-xs text-bold px-4 py-2 inline-block rounded cursor-pointer" @click="$refs.dialogAddBusiness.show()" style="margin-top: -5px;"><i class="fa fa-plus mr-2"></i> ADD NEW BUSINESS</div>
            </div>
            
            <br /><br /><br /><br /><br />
          </div>
        </v-card>
      </div>

      <template v-if="!fetchingBusinesses && businesses.length > 0">
          
        <div class="dashboard-box">
          <v-card
            class="pa-2"
            tile
          >
            <div class="p-3">

            plm

              <v-data-table
                :headers="((isAccelerate()) ? headers : headers_diy)"
                :items="businesses"
                :items-per-page="20"
                class="rg-datatable elevation-1"
                :footer-props="{
                itemsPerPageOptions: [10, 20, 30, 40, 50, 100],
                showFirstLastPage: true
                }"
                mobile-breakpoint="10"
                :search="search"
                item-key="id"
                show-expand
                :expanded.sync="expanded"
                >
                    <template v-slot:top>
                      <v-text-field
                        clearable
                        outlined
                        dense
                        hide-details
                        prepend-inner-icon="mdi-magnify"
                        label="Search"
                        v-model="search"

                        class="white border border-white"
                        style="width: 100%; max-width: 300px; margin-bottom: 10px;"
                      ></v-text-field>
                    </template>

                    <template v-slot:expanded-item="{ item }">
                      <td :colspan="(headers.length + 1)">
                        <div v-if="item.children && item.children.length">
                          <v-simple-table dense>
                            <thead>
                              <tr>
                                <th>Name</th>
                                <th>Audit Keywords Allowed</th>
                                <th>Local SEO Tab</th>
                                <th>&nbsp;</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="child in item.children" :key="child.id">
                                <td>
                                  {{ child.company_name }}

                                  <span v-if="child.city">
                                    - {{ child.city }}
                                  </span>

                                  <span v-if="child.city && child.state">
                                    , {{ child.state }}
                                  </span>
                                </td>
                                <td>
                                  <v-text-field
                                    v-show="child.allowed_lsa_keywords"
                                    clearable
                                    outlined
                                    dense
                                    hide-details
                                    v-model="child.allowed_lsa_keywords"

                                    class="white border border-white"
                                    style="width: 100%; max-width: 100px; margin-bottom: 10px;"
                                    @keyup="saveAllowedAuditKeywords(child)"
                                    @blur="changesSaved()"
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-chip
                                    v-if="item.local_seo_tab == 1"
                                  
                                    small
                                    color="green lighten-5"
                                    text-color="green lighten-1"
                                  >
                                    Enabled
                                  </v-chip>

                                  <v-chip
                                    v-if="item.local_seo_tab == 0"
                                  
                                    small
                                    color="red lighten-5"
                                    text-color="red"
                                  >
                                    Disabled
                                  </v-chip>

                                  <v-text-field
                                    v-show="item.local_seo_tab == 1"
                                    clearable
                                    outlined
                                    dense
                                    hide-details
                                    label="BrightLocal Report URL"
                                    v-model="child.brightlocal_report_url"

                                    class="white border border-white"
                                    style="width: 100%; max-width: 300px; margin-bottom: 10px;"
                                    @keyup="saveBrightLocalUrl(child)"
                                    @blur="changesSaved()"
                                  ></v-text-field>
                                </td>
                                <td>
                                  <!-- <v-menu
                                    bottom
                                    left
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        dark
                                        icon
                                        v-bind="attrs"
                                        v-on="on"
                                        class="ml-3"
                                        color="grey darken-1"
                                      >
                                        <i class="mdi mdi-dots-vertical"></i>
                                      </v-btn>
                                    </template>

                                    <v-list class="table-menu-actions">
                                      <v-list-item v-if="child.local_seo_tab == 1" class="hover:bg-gray-200"><v-list-item-title><a href="javascript: void(0);" @click="disableLocalSeoTab(child)"><span class="table-menu-action-icon"><i class="mdi mdi-close"></i></span> Disable Local SEO Tab</a></v-list-item-title></v-list-item>
                                      <v-list-item v-if="child.local_seo_tab == 0" class="hover:bg-gray-200"><v-list-item-title><a href="javascript: void(0);" @click="allowLocalSeoTab(child)"><span class="table-menu-action-icon"><i class="mdi mdi-check"></i></span> Enable Local SEO Tab</a></v-list-item-title></v-list-item>
                                    </v-list>
                                  </v-menu> -->
                                </td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                        </div>
                        <div v-else>
                          <em>No secondary locations found.</em>
                        </div>
                      </td>
                    </template>
                
                    <template v-slot:item.email="{ item }">
                      {{ item.email ? item.email : '-' }}
                    </template>

                    <template v-slot:item.a2p_status="{ item }">
                      <v-chip
                        v-if="item.a2p_status == 1"
                       
                        small
                        color="green lighten-5"
                        text-color="green lighten-1"
                      >
                        Approved
                      </v-chip>

                      <v-chip
                        v-if="item.a2p_status == 0"
                       
                        small
                        color="gray darken-1"
                        text-color="gray"
                      >
                        Not Submitted
                      </v-chip>

                      <v-chip
                        v-if="item.a2p_status == 2"
                       
                        small
                        color="orange lighten-5"
                        text-color="orange"
                      >
                        Pending
                      </v-chip>
                    </template>

                    <template v-slot:item.allow_changing_promp="{ item }">
                      <v-chip
                        v-if="item.allow_changing_promp == 1"
                       
                        small
                        color="green lighten-5"
                        text-color="green lighten-1"
                      >
                        Allowed
                      </v-chip>

                      <v-chip
                        v-if="item.allow_changing_promp == 0"
                       
                        small
                        color="red lighten-5"
                        text-color="red"
                      >
                        Not Allowed
                      </v-chip>
                    </template>

                    <template v-slot:item.allow_changing_tags_status="{ item }">
                      <v-chip
                        v-if="item.allow_changing_tags_status == 1"
                       
                        small
                        color="green lighten-5"
                        text-color="green lighten-1"
                      >
                        Allowed
                      </v-chip>

                      <v-chip
                        v-if="item.allow_changing_tags_status == 0"
                       
                        small
                        color="red lighten-5"
                        text-color="red"
                      >
                        Not Allowed
                      </v-chip>
                    </template>

                    <template v-slot:item.request_reviews_access="{ item }">
                      <v-chip
                        v-if="item.request_reviews_access == 1"
                      
                        small
                        color="green lighten-5"
                        text-color="green lighten-1"
                      >
                        Enabled
                      </v-chip>

                      <v-chip
                        v-if="item.request_reviews_access == 0"
                      
                        small
                        color="red lighten-5"
                        text-color="red"
                      >
                        Disabled
                      </v-chip>
                    </template>

                    <template v-slot:item.local_seo_tab="{ item }">
                      <v-chip
                        v-if="item.local_seo_tab == 1"
                      
                        small
                        color="green lighten-5"
                        text-color="green lighten-1"
                      >
                        Enabled
                      </v-chip>

                      <v-chip
                        v-if="item.local_seo_tab == 0"
                      
                        small
                        color="red lighten-5"
                        text-color="red"
                      >
                        Disabled
                      </v-chip>

                      <v-text-field
                        v-show="item.local_seo_tab"
                        clearable
                        outlined
                        dense
                        hide-details
                        label="BrightLocal Report URL"
                        v-model="item.brightlocal_report_url"

                        class="white border border-white"
                        style="width: 100%; max-width: 300px; margin-bottom: 10px;"
                        @keyup="saveBrightLocalUrl(item)"
                        @blur="changesSaved()"
                      ></v-text-field>
                    </template>

                    <template v-slot:item.allowed_lsa_keywords="{ item }">
                      <v-text-field
                        v-show="item.allowed_lsa_keywords"
                        clearable
                        outlined
                        dense
                        hide-details
                        v-model="item.allowed_lsa_keywords"

                        class="white border border-white"
                        style="width: 100%; max-width: 100px; margin-bottom: 10px;"
                        @keyup="saveAllowedAuditKeywords(item)"
                        @blur="changesSaved()"
                      ></v-text-field>
                    </template>

                    <template v-slot:item.auto_delete="{ item }">
                      <div style="position: relative;">
                        <v-switch color="#48bb78" inset dense hide-details :ripple="false" v-model="item.auto_delete" @change="toggleAutoDelete(item)"></v-switch>

                        <div style="position: absolute; top: 0px; margin-left: 42px;">
                          <v-tooltip top color="primary">
                            <template #activator="{ on, attrs }">
                              <i v-bind="attrs" v-on="on" class="mdi mdi-information-outline" style="font-size: 16px;"></i>
                            </template>
                            <span>Auto Delete free accounts that are using only AI and not LSA and have not been active in 30 days.</span>
                          </v-tooltip>
                        </div>
                      </div>
                    </template>

                    <template v-slot:item.hide_recordings_transcripts="{ item }">
                      <div style="position: relative;">
                        <v-switch color="#48bb78" inset dense hide-details :ripple="false" v-model="item.hide_recordings_transcripts" @change="toggleHideTranscripts(item)"></v-switch>

                        <div style="position: absolute; top: 0px; margin-left: 42px;">
                          <v-tooltip top color="primary">
                            <template #activator="{ on, attrs }">
                              <i v-bind="attrs" v-on="on" class="mdi mdi-information-outline" style="font-size: 16px;"></i>
                            </template>
                            <span>Hide recording/transcript for HIPA non-compliant data.</span>
                          </v-tooltip>
                        </div>
                      </div>
                    </template>

                    <template v-slot:item.id="{ item }">
                      <v-menu
                        bottom
                        left
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            dark
                            icon
                            v-bind="attrs"
                            v-on="on"
                            class="ml-3"
                            color="grey darken-1"
                          >
                            <i class="mdi mdi-dots-vertical"></i>
                          </v-btn>
                        </template>

                        <v-list class="table-menu-actions">
                          <v-list-item v-if="item.a2p_status == 2" class="hover:bg-gray-200"><v-list-item-title><a href="javascript: void(0);" @click="approvedA2p(item)"><span class="table-menu-action-icon"><i class="mdi mdi-check"></i></span> Set A2P Status Approved</a></v-list-item-title></v-list-item>
                          <v-list-item v-if="item.a2p_status == 0" class="hover:bg-gray-200"><v-list-item-title><a href="javascript: void(0);" @click="pendingA2p(item)"><span class="table-menu-action-icon"><i class="mdi mdi-stop"></i></span> Set A2P Status Pending</a></v-list-item-title></v-list-item>

                          <v-divider></v-divider>
                          
                          <v-list-item v-if="item.allow_changing_promp == 1" class="hover:bg-gray-200"><v-list-item-title><a href="javascript: void(0);" @click="disablePrompt(item)"><span class="table-menu-action-icon"><i class="mdi mdi-close"></i></span> Disallow Changing Prompt</a></v-list-item-title></v-list-item>
                          <v-list-item v-if="item.allow_changing_promp == 0" class="hover:bg-gray-200"><v-list-item-title><a href="javascript: void(0);" @click="allowPrompt(item)"><span class="table-menu-action-icon"><i class="mdi mdi-check"></i></span> Allow Changing Prompt</a></v-list-item-title></v-list-item>
                          
                          <v-divider></v-divider>
                          
                          <v-list-item v-if="item.allow_changing_tags_status == 1" class="hover:bg-gray-200"><v-list-item-title><a href="javascript: void(0);" @click="disableTagsStatus(item)"><span class="table-menu-action-icon"><i class="mdi mdi-close"></i></span> Disallow Changing Tags/Status</a></v-list-item-title></v-list-item>
                          <v-list-item v-if="item.allow_changing_tags_status == 0" class="hover:bg-gray-200"><v-list-item-title><a href="javascript: void(0);" @click="allowTagsStatus(item)"><span class="table-menu-action-icon"><i class="mdi mdi-check"></i></span> Allow Changing Tags/Status</a></v-list-item-title></v-list-item>
                          
                          <v-divider></v-divider>
                          
                          <v-list-item v-if="item.request_reviews_access == 1" class="hover:bg-gray-200"><v-list-item-title><a href="javascript: void(0);" @click="disableReviewRequest(item)"><span class="table-menu-action-icon"><i class="mdi mdi-close"></i></span> Disable Review Request</a></v-list-item-title></v-list-item>
                          <v-list-item v-if="item.request_reviews_access == 0" class="hover:bg-gray-200"><v-list-item-title><a href="javascript: void(0);" @click="allowReviewRequest(item)"><span class="table-menu-action-icon"><i class="mdi mdi-check"></i></span> Enable Review Request</a></v-list-item-title></v-list-item>

                          <v-divider></v-divider>
                          
                          <v-list-item v-if="item.local_seo_tab == 1" class="hover:bg-gray-200"><v-list-item-title><a href="javascript: void(0);" @click="disableLocalSeoTab(item)"><span class="table-menu-action-icon"><i class="mdi mdi-close"></i></span> Disable Local SEO Tab</a></v-list-item-title></v-list-item>
                          <v-list-item v-if="item.local_seo_tab == 0" class="hover:bg-gray-200"><v-list-item-title><a href="javascript: void(0);" @click="allowLocalSeoTab(item)"><span class="table-menu-action-icon"><i class="mdi mdi-check"></i></span> Enable Local SEO Tab</a></v-list-item-title></v-list-item>
                        </v-list>
                      </v-menu>
                    </template>
                </v-data-table>
          </div>
          </v-card>
        </div>
      </template>

    </panel-navigation>

</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import PanelNavigation from '@/components/PanelNavigation.vue'
import moment from 'moment'
import dialogAddBusiness from '@/components/dialogs/businesses/addBusiness.vue'

export default {
  metaInfo () {
    return {
      title: "AI Admin | " + this.$appName
    }
  },
  components: {
    PanelNavigation,
    dialogAddBusiness
  },
  data() {
    return {
      selectedBusinessIds: [],

      search: "",

      headers: [
        { text: '', value: 'data-table-expand', sortable: false }, // 👈 this adds the expand icon
        { text: 'Name', value: 'company_name' },
        { text: 'A2P Status', value: 'a2p_status' },
        { text: 'Allow Changing Prompt', value: 'allow_changing_promp' },
        { text: 'Allow Changing Tags/Status', value: 'allow_changing_tags_status' },
        { text: 'Request Reviews Access', value: 'request_reviews_access' },
        { text: 'Local SEO Tab', value: 'local_seo_tab' },
        { text: 'Audit Keywords Allowed', value: 'allowed_lsa_keywords' },
        { text: '', value: 'id', sortable: false }
      ],

      headers_diy: [
        { text: '', value: 'data-table-expand', sortable: false }, // 👈 this adds the expand icon
        { text: 'Name', value: 'company_name' },
        { text: 'A2P Status', value: 'a2p_status' },
        { text: 'Allow Changing Prompt', value: 'allow_changing_promp' },
        { text: 'Allow Changing Tags/Status', value: 'allow_changing_tags_status' },
        { text: 'Request Reviews Access', value: 'request_reviews_access' },
        { text: 'Local SEO Tab', value: 'local_seo_tab' },
        { text: 'Audit Keywords Allowed', value: 'allowed_lsa_keywords' },
        { text: 'Auto Delete', value: 'auto_delete' },
        { text: 'Hide Transcripts/Recordings', value: 'hide_recordings_transcripts' },
        { text: '', value: 'id', sortable: false }
      ],
      
      expanded: []
    }
  },
  computed: {
    ...mapState({
      businesses: state => state.businesses.businesses,
      fetchingBusinesses: state => state.businesses.fetchingBusinesses,
      me: state => state.me.me,
      profile: state => state.me.profile
    }),
    sortedBusinesses() {
      return this.businesses.slice().sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    }
  },
  methods: {
     getHost() {
      return window.location.host;
    },

    isAccelerate() {
       // || this.getHost() == 'zany-space-palm-tree-q9vjg4xr39j97-8080.app.github.dev'
      return this.getHost() == 'lsa.accelerateyourmarketing.com';
    },

    toggleAutoDelete(item) {
      console.log('diitem', item.auto_delete);

      axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/toggle-auto-delete`, {
          id: item.id,
          auto_delete: ((item.auto_delete) ? 1 : 0),
        },
        {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })
    },

    toggleHideTranscripts(item) {
      console.log('diitem', item.hide_recordings_transcripts);

      axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/toggle-hide-transcripts`, {
          id: item.id,
          hide_recordings_transcripts: ((item.hide_recordings_transcripts) ? 1 : 0),
        },
        {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })
    },

    async pendingA2p(business) {
      this.$store.state.businesses.fetchingBusinesses = true

      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/pending-a2p`, {
          id: business.id
        },
        {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      this.$store.dispatch('businesses/fetch')

      this.changesSaved();
    },

    async approvedA2p(business) {
      this.$store.state.businesses.fetchingBusinesses = true

      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/approved-a2p`, {
          id: business.id
        },
        {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      this.$store.dispatch('businesses/fetch')

      this.changesSaved();
    },

    async allowPrompt(business) {
      this.$store.state.businesses.fetchingBusinesses = true

      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/enable-prompt`, {
          id: business.id
        },
        {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      this.$store.dispatch('businesses/fetch')

      this.changesSaved();
    },

    async disablePrompt(business) {
      this.$store.state.businesses.fetchingBusinesses = true

      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/disable-prompt`, {
          id: business.id
        },
        {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      this.$store.dispatch('businesses/fetch')

      this.changesSaved();
    },

    async allowTagsStatus(business) {
      this.$store.state.businesses.fetchingBusinesses = true

      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/enable-tags-status`, {
          id: business.id
        },
        {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      this.$store.dispatch('businesses/fetch')

      this.changesSaved();
    },

    async disableTagsStatus(business) {
      this.$store.state.businesses.fetchingBusinesses = true

      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/disable-tags-status`, {
          id: business.id
        },
        {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      this.$store.dispatch('businesses/fetch')

      this.changesSaved();
    },



    async allowReviewRequest(business) {
      this.$store.state.businesses.fetchingBusinesses = true

      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/enable-review-request`, {
          id: business.id
        },
        {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      this.$store.dispatch('businesses/fetch')

      this.changesSaved();
    },

    async disableReviewRequest(business) {
      this.$store.state.businesses.fetchingBusinesses = true

      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/disable-review-request`, {
          id: business.id
        },
        {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      this.$store.dispatch('businesses/fetch')

      this.changesSaved();
    },

    async allowLocalSeoTab(business) {
      this.$store.state.businesses.fetchingBusinesses = true

      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/enable-local-seo-tab`, {
          id: business.id
        },
        {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      this.$store.dispatch('businesses/fetch')

      this.changesSaved();
    },

    async disableLocalSeoTab(business) {
      this.$store.state.businesses.fetchingBusinesses = true

      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/disable-local-seo-tab`, {
          id: business.id
        },
        {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      this.$store.dispatch('businesses/fetch')

      this.changesSaved();
    },

    

    async saveBrightLocalUrl(business) {
      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/save-bright-local-url`, {
          id: business.id,
          brightlocal_report_url: business.brightlocal_report_url
        },
        {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })
    },

    async saveAllowedAuditKeywords(business) {
      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/save-allowed-audit-keywords`, {
          id: business.id,
          allowed_lsa_keywords: business.allowed_lsa_keywords
        },
        {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })
    },

    changesSaved() {
      this.$swal({
        title: "Changes Saved!",
        text: "Changes have been updated successfully!",
        showCancelButton: false,
      });
    },

    formatDate(date) {
      return moment(date).format("MMM D, YYYY")
    },
  },
  mounted() {
    this.$store.state.businesses.fetchingBusinesses = true
    this.$store.dispatch('businesses/fetch')

    let self = this
    setTimeout(function() {
      if (self.me.company_type != 'agency') {
        self.$router.push('/dashboard')
      }
    }, 1000);
  }
}
</script>

<style lang="scss" scoped>
  
</style>
